import { render, staticRenderFns } from "./add-result.vue?vue&type=template&id=a73a8ebc&scoped=true&"
import script from "./add-result.vue?vue&type=script&lang=js&"
export * from "./add-result.vue?vue&type=script&lang=js&"
import style0 from "./add-result.vue?vue&type=style&index=0&id=a73a8ebc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a73a8ebc",
  null
  
)

export default component.exports